export const VIEW = 'index';
export const MANAGE = 'manage';
export const UPDATE = 'update';
export const DESTROY = 'destroy';
export const CREATE = 'create';
export const IMPORT = 'import';
